<template>
    <div class="stats-dashboard">
        <template v-if="loading">
            <v-skeleton-loader type="card" height="80px" />
            <v-skeleton-loader type="image" height="300px" />
            <v-skeleton-loader type="image" height="500px" />
        </template>

        <template v-else>
            <SummaryStats :stats="stats.sessionAndViewedPageCount" />
            <SessionsChart :sessionCountByDay="stats.sessionCountByDay" />
            <VisitsMap :visitsMapData="stats.visitsMapData" />
        </template>
    </div>
</template>

<script>
import SummaryStats from '@/components/statistic/SummaryStats.vue';
import SessionsChart from '@/components/statistic/SessionsChart.vue';
import VisitsMap from '@/components/statistic/VisitsMap.vue';
import { api } from '@/utils/api';

export default {
    name: 'MainDashboard',
    components: {
        SummaryStats,
        SessionsChart,
        VisitsMap
    },
    data() {
        return {
            loading: true,
            stats: {
                sessionAndViewedPageCount: { visitNumber: 0, viewedPageNumber: 0 },
                sessionCountByDay: {},
                visitsMapData: {}
            }
        };
    },
    mounted() {
        this.fetchStats();
    },
    methods: {
        async fetchStats() {
            try {
                this.stats = await api.get(['Statistic', 'getStatistic'], { clientName: this.$route.params.client });
            } catch (error) {
                this.$store.commit('displayErrors', {
                    errno: 3402
                });
            }
            this.loading = false;
        }
    }
};
</script>

<style scoped>
.stats-dashboard {
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 800px;
    margin: 0 auto;
}
</style>
